<ng-container *ngIf="!showWarning; else warning">
  <app-dialog
    id="import-dialog"
    [title]="title"
    (save)="onSubmit()"
    [confirmation]="'button.submit' | translate"
    [isValid]="!!selection.selected.length"
    [counter]="selection.selected.length"
  >
    <form [formGroup]="formGroup">
      <div class="row accountSelect">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'importDialog.importFrom' | translate }}</mat-label>
          <mat-select
            #select
            formControlName="account"
            [placeholder]="'importDialog.placeholder' | translate"
            (selectionChange)="onSelectionChange($event)"
          >
            <mat-select-filter
              *ngIf="select.focused"
              [array]="accounts"
              [displayMember]="'account'"
              (filteredReturn)="filteredAccounts = $event.length > 0 ? $event : accounts"
            ></mat-select-filter>
            <mat-option *ngFor="let account of filteredAccounts" [value]="account.uid">{{
              account.account
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <ng-container *ngIf="!isLoading && selectedAccountUid">
        <mat-table [dataSource]="dataSource" class="mat-elevation-z2">
          <ng-container matColumnDef="{{ column }}" *ngFor="let column of columns">
            <ng-container *ngIf="column !== 'select'; else selectColumn">
              <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
              <td mat-cell *matCellDef="let row">{{ row[column] }}</td>
            </ng-container>

            <ng-template #selectColumn>
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="$event ? toggleAllRows() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()"
                  [aria-label]="checkboxLabel()"
                >
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)"
                  [aria-label]="checkboxLabel(row)"
                >
                </mat-checkbox>
              </td>
            </ng-template>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>

          <tr mat-row *matRowDef="let element; columns: columns"></tr>
        </mat-table>
      </ng-container>
    </form>
  </app-dialog>
</ng-container>

<ng-template #warning>
  <app-dialog
    id="warning"
    [title]="'importDialog.warning.title' | translate"
    (save)="onSave()"
    [backButton]="showWarning"
    (back)="onWarningCancel()"
    [confirmation]="'button.import' | translate"
  >
    <div mat-dialog-content>
      <p>
        {{ 'importDialog.warning.content' | translate : { value: selection.selected.length } }}
      </p>
    </div>
  </app-dialog>
</ng-template>
